export const API_URL = 'https://ai-art-free-api.martjay521.workers.dev';
